import Bowser from 'bowser';
import { APP_VERSION } from '@vfit/consumer/data-access';
import { IRegisterDevicePayload } from './device.models';

const retrieveRegisterPayload = (): IRegisterDevicePayload => {
  const bowser = Bowser.getParser(navigator.userAgent);
  const os = bowser.getOS();
  const platform = bowser.getPlatform();
  const isTablet = bowser.getPlatformType() === 'tablet';
  const platformType = bowser.getPlatformType() === 'mobile' ? 'Mobile' : 'Desktop';

  const generateUUID = () => {
    const url = URL.createObjectURL(new Blob());
    return url.substring(url.lastIndexOf('/') + 1);
  };

  return {
    appVersion: APP_VERSION,
    osVersion: os.version,
    pushToken: '',
    pushProvider: '',
    pushType: 'broadcast-simple',
    muid: 'CxIubggh4NJYoynR',
    cid: 'PtnMVOBJ',
    appKey: 'ap1pmcgHqn',
    deviceUdid: generateUUID(),
    appPlatform: platformType,
    osName: os.name,
    deviceVendor: platform?.vendor || 'web',
    deviceModel: platform?.model || 'desktop',
    deviceIsTablet: isTablet,
    screenWidth: window.screen.width.toString(),
    screenHeight: window.screen.height.toString(),
    screenRatio: window.devicePixelRatio.toString(),
    appId: 'MyVodafoneWeb',
    locale: 'it',
  };
};

export { retrieveRegisterPayload };
